import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TabsModule } from 'beyond-util';
import { NepriznataEmitovanjaComponent } from './nepriznata-emitovanja.component';

@NgModule({
  declarations: [NepriznataEmitovanjaComponent],
  entryComponents: [NepriznataEmitovanjaComponent],
  exports: [NepriznataEmitovanjaComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
  ],
})
export class NepriznataEmitovanjaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/nepriznata-emitovanja/nepriznata-emitovanja.module.ts